import axios from 'axios'
import library from '../../../utils/Library'

export const helpAddFileExtends = async (extend) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('fileExtend') + '/create'
  return await axios({
    url: URL,
    method: 'POST',
    data: {
      fileExtension: {
        extensionName: extend,
        extensionCharCode: extend,
        encodedIconImage: 'data:image/jpg;base64,fjzufgsuayifukhgkj',
        technicalData: {
          signature: ['FFD8FFE0', 'FFD8FFE1', 'FFD8FFE8']
        }
      }
    },
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
